'use strict';

var _classCallCheck = require("/Users/orie/OR13/create-react-app-orbit-db/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/create-react-app-orbit-db/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/orie/OR13/create-react-app-orbit-db/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/OR13/create-react-app-orbit-db/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/orie/OR13/create-react-app-orbit-db/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/Users/orie/OR13/create-react-app-orbit-db/node_modules/@babel/runtime/helpers/assertThisInitialized");

var diff = require('hyperdiff');

var EventEmitter = require('events');

var timers = require('timers');

var clone = require('lodash.clonedeep');

var PROTOCOL = require('./protocol');

var Connection = require('./connection');

var encoding = require('./encoding');

var directConnection = require('./direct-connection-handler');

var DEFAULT_OPTIONS = {
  pollInterval: 1000
};

module.exports = function (ipfs, topic, options) {
  return new PubSubRoom(ipfs, topic, options);
};

var PubSubRoom =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(PubSubRoom, _EventEmitter);

  function PubSubRoom(ipfs, topic, options) {
    var _this;

    _classCallCheck(this, PubSubRoom);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PubSubRoom).call(this));
    _this._ipfs = ipfs;
    _this._topic = topic;
    _this._options = Object.assign({}, clone(DEFAULT_OPTIONS), clone(options));
    _this._peers = [];
    _this._connections = {};
    _this._handleDirectMessage = _this._handleDirectMessage.bind(_assertThisInitialized(_assertThisInitialized(_this)));

    if (!_this._ipfs.pubsub) {
      throw new Error('This IPFS node does not have pubsub.');
    }

    if (_this._ipfs.isOnline()) {
      _this._start();
    } else {
      _this._ipfs.on('ready', _this._start.bind(_assertThisInitialized(_assertThisInitialized(_this))));
    }

    _this._ipfs.on('stop', _this.leave.bind(_assertThisInitialized(_assertThisInitialized(_this))));

    return _this;
  }

  _createClass(PubSubRoom, [{
    key: "getPeers",
    value: function getPeers() {
      return this._peers.slice(0);
    }
  }, {
    key: "hasPeer",
    value: function hasPeer(peer) {
      return this._peers.indexOf(peer) >= 0;
    }
  }, {
    key: "leave",
    value: function leave() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        timers.clearInterval(_this2._interval);
        Object.keys(_this2._connections).forEach(function (peer) {
          _this2._connections[peer].stop();
        });
        directConnection.emitter.removeListener(_this2._topic, _this2._handleDirectMessage);

        _this2.once('stopped', function () {
          return resolve();
        });

        _this2.emit('stopping');
      });
    }
  }, {
    key: "broadcast",
    value: function broadcast(_message) {
      var _this3 = this;

      var message = encoding(_message);

      this._ipfs.pubsub.publish(this._topic, message, function (err) {
        if (err) {
          _this3.emit('error', err);
        }
      });
    }
  }, {
    key: "sendTo",
    value: function sendTo(peer, message) {
      var _this4 = this;

      var conn = this._connections[peer];

      if (!conn) {
        conn = new Connection(peer, this._ipfs, this);
        conn.on('error', function (err) {
          return _this4.emit('error', err);
        });
        this._connections[peer] = conn;
        conn.once('disconnect', function () {
          delete _this4._connections[peer];
          _this4._peers = _this4._peers.filter(function (p) {
            return p !== peer;
          });

          _this4.emit('peer left', peer);
        });
      } // We should use the same sequence number generation as js-libp2p-floosub does:
      // const seqno = Buffer.from(utils.randomSeqno())
      // Until we figure out a good way to bring in the js-libp2p-floosub's randomSeqno
      // generator, let's use 0 as the sequence number for all private messages
      // const seqno = Buffer.from([0])


      var seqno = Buffer.from([0]);
      var msg = {
        to: peer,
        from: this._ipfs._peerInfo.id.toB58String(),
        data: Buffer.from(message).toString('hex'),
        seqno: seqno.toString('hex'),
        topicIDs: [this._topic],
        topicCIDs: [this._topic]
      };
      conn.push(Buffer.from(JSON.stringify(msg)));
    }
  }, {
    key: "_start",
    value: function _start() {
      var _this5 = this;

      this._interval = timers.setInterval(this._pollPeers.bind(this), this._options.pollInterval);

      var listener = this._onMessage.bind(this);

      this._ipfs.pubsub.subscribe(this._topic, listener, {}, function (err) {
        if (err) {
          _this5.emit('error', err);
        } else {
          _this5.emit('subscribed', _this5._topic);
        }
      });

      this.once('stopping', function () {
        _this5._ipfs.pubsub.unsubscribe(_this5._topic, listener, function (err) {
          if (err) {
            _this5.emit('error', err);
          } else {
            _this5.emit('stopped');
          }
        });
      });

      this._ipfs._libp2pNode.handle(PROTOCOL, directConnection.handler);

      directConnection.emitter.on(this._topic, this._handleDirectMessage);
    }
  }, {
    key: "_pollPeers",
    value: function _pollPeers() {
      var _this6 = this;

      this._ipfs.pubsub.peers(this._topic, function (err, _newPeers) {
        if (err) {
          _this6.emit('error', err);

          return; // early
        }

        var newPeers = _newPeers.sort();

        if (_this6._emitChanges(newPeers)) {
          _this6._peers = newPeers;
        }
      });
    }
  }, {
    key: "_emitChanges",
    value: function _emitChanges(newPeers) {
      var _this7 = this;

      var differences = diff(this._peers, newPeers);
      differences.added.forEach(function (addedPeer) {
        return _this7.emit('peer joined', addedPeer);
      });
      differences.removed.forEach(function (removedPeer) {
        return _this7.emit('peer left', removedPeer);
      });
      return differences.added.length > 0 || differences.removed.length > 0;
    }
  }, {
    key: "_onMessage",
    value: function _onMessage(message) {
      this.emit('message', message);
    }
  }, {
    key: "_handleDirectMessage",
    value: function _handleDirectMessage(message) {
      if (message.to === this._ipfs._peerInfo.id.toB58String()) {
        var m = Object.assign({}, message);
        delete m.to;
        this.emit('message', m);
      }
    }
  }]);

  return PubSubRoom;
}(EventEmitter);